import { Checkbox, Form, Typography, Input as InputAntd } from "antd";
import React, { useEffect, useState } from "react";
import ReactInputMask from "react-input-mask";
import { useNavigate } from "react-router-dom";
import { LoadingOutlined } from "@ant-design/icons";
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import {
  Button,
  FormControl,
  IconButton,
  Input,
  InputAdornment,
  InputLabel,
  TextField,
} from "@mui/material";
import ButtonTeste from "../../components/Button";
import { cpfInputMask } from "../../utils";
import { useAuth } from "../../contexts/AuthContext";
import { AuthContainer } from "../../styles/LoginSignUp/authContainer";
import {
  validationCpf,
  validationEmail,
  validationFullName,
  validationPassword,
} from "../../utils/formValidations";

interface IData {
  email: string;
  pass: string;
  passConfirmation: string;
  cpf: string;
  name: string;
}

interface IProps {
  className?: string;
}

const MaskCPF = React.forwardRef<HTMLElement>((props, ref) => (
  <ReactInputMask {...props} mask={cpfInputMask} />
));

const Cadastro: React.FC<IProps> = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm<IData>();
  const { handleSignUp, loading } = useAuth();
  const [showPassword, setShowPassword] = useState(false);
  const [fieldsError, setFieldsError] = useState<{ [key: string]: string[] }>(
    {}
  );

  const onFinish = (data: IData) => {
    handleSignUp(data, {});
  };

  const onValuesChange = (changed: any, values: any) => {
    const cpf = changed.cpf ? changed.cpf.replace(/[_.-/-]/g, "") : values.cpf;
    form.setFieldsValue({
      ...values,
      cpf,
    });
  };

  const onFieldsChange = () => {
    setFieldsError(
      form
        .getFieldsError()
        .reduce((acc, cur) => ({ ...acc, [cur.name?.[0]]: cur.errors }), {})
    );
  };

  useEffect(() => {
    // Redireciona automaticamente para a tela de login
    navigate("/p/login", { replace: true });
  }, [navigate]);

  return (
    <AuthContainer className="beauty-scrollbar">
      <div className="auth-content">
        <div className="form-container">
          <Typography.Title level={1}>Faça seu cadastro</Typography.Title>
          <Form
            form={form}
            size="large"
            onFinish={onFinish}
            onValuesChange={onValuesChange}
            onFieldsChange={onFieldsChange}
          >
            <Form.Item name="name" rules={validationFullName}>
              <InputAntd placeholder="Nome completo" />
            </Form.Item>

            <Form.Item name="cpf" rules={validationCpf}>
              <ReactInputMask
                placeholder="CPF"
                mask="999.999.999-99"
                className="ant-input ant-input-lg"
              />
            </Form.Item>

            <Form.Item name="email" rules={validationEmail}>
              <InputAntd placeholder="Email" />
            </Form.Item>

            {/* <Form.Item name="pass" rules={validationPassword}>
              <FormControl fullWidth variant="standard">
                <InputLabel htmlFor="input-password">Senha</InputLabel>
                <Input
                  id="input-password"
                  type={showPassword ? "text" : "password"}
                  error={fieldsError["pass"]?.length > 0}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="exibir senha"
                        onMouseDown={(e) => e.preventDefault()}
                        onClick={() => setShowPassword((show) => !show)}
                        edge="end"
                      >
                        {showPassword ? <MdVisibilityOff /> : <MdVisibility />}
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </FormControl>
            </Form.Item> */}
            <div className="password-with-eye">
              <Form.Item name="pass" rules={validationPassword}>
                {showPassword ? (
                  <InputAntd placeholder="Senha" />
                ) : (
                  <InputAntd.Password
                    placeholder="Senha"
                    visibilityToggle={false}
                  />
                )}
              </Form.Item>
              <ButtonTeste
                size="large"
                type="text"
                onClick={() => setShowPassword((show) => !show)}
                icon={showPassword ? <EyeInvisibleOutlined /> : <EyeOutlined />}
              />
            </div>

            <Form.Item
              name="policiesAccepted"
              getValueFromEvent={(e) => e.target.checked}
            >
              <Checkbox>
                <span>
                  Li, entendi e estou de acordo com os{" "}
                  <a
                    href="https://velotax-assets.s3.us-east-1.amazonaws.com/reports/Velotax+-+Termos+de+Uso+27Ago25.pdf"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Termos de Uso
                  </a>
                  ,{" "}
                  <a
                    href="https://velotax-assets.s3.us-east-1.amazonaws.com/reports/Velotax+-+Pol%C3%ADtica+de+Privacidade+27Ago25.pdf"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Política de Privacidade
                  </a>{" "}
                  e{" "}
                  <a
                    href="https://velotax-assets.s3.us-east-1.amazonaws.com/reports/Velotax+-+Termos+e+Condi%C3%A7%C3%B5es+de+Contrata%C3%A7%C3%A3o+27Ago25.pdf"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Termos e Condições de Contratação
                  </a>{" "}
                  do VeloPrime.
                </span>
              </Checkbox>
            </Form.Item>

            <div className="buttons">
              <Button
                size="large"
                type="submit"
                color="primary"
                variant="contained"
                className="full-width"
                disabled={loading}
                startIcon={loading && <LoadingOutlined />}
              >
                Começar
              </Button>
            </div>
          </Form>

          <div className="footer">
            Já possui uma conta?
            <Button
              type="button"
              disabled={loading}
              onClick={() => navigate("/p/login")}
            >
              <span className="velotax-link">Entrar</span>
            </Button>
          </div>
        </div>
      </div>
    </AuthContainer>
  );
};

export default Cadastro;
